import { Container, rem, Text, useMantineTheme } from '@mantine/core';

export const ErrorPageUnspecified = () => {
  const theme = useMantineTheme();
  return (
    <Container style={{ paddingTop: rem(80), paddingBottom: rem(80) }}>
      <Text
        c={theme.colors.dark[6]}
        size="lg"
        style={{
          textAlign: 'center',
          maxWidth: rem(500),
          margin: 'auto',
        }}
      >
        There is a problem with your request.
      </Text>
      <Text
        c={theme.colors.dark[6]}
        size="lg"
        style={{
          textAlign: 'center',
          maxWidth: rem(500),
          margin: 'auto',
        }}
      >
        Error code: <b>13e</b>
      </Text>
    </Container>
  );
};
